"use client";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTerms } from "@/redux/Slice/termsAndPolicy/termsAndPolicySlice";
import LegalHero from "@/components/pages/legal/LegalHero";
import LegalContent from "@/components/pages/legal/LegalContent";

export default function TermsOfService() {
  const dispatch = useDispatch();
  const { termsOfService, status } = useSelector((state) => state.terms);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getTerms());
    }
  }, [dispatch, status]);

  return (
    <>
      <LegalHero
        title="Terms of Service"
        subtitle="The rules of the road for using Imagive clear, fair, and written to be read."
        lastUpdated="June 17, 2026"
        effective="June 17, 2026"
        version="2.1"
      />
      <div className="px-4 md:px-16 lg:px-20 py-12">
        <LegalContent
          status={status}
          html={termsOfService?.text}
          subject="terms of service"
        />
      </div>
    </>
  );
}
